import '@fontsource-variable/noto-sans-bengali';
import './styles/index.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from '@dd/ui';
import { App } from './App';
import { registerSW } from './lib/pwa';
import { watchInstall } from './lib/install';

watchInstall();
void registerSW();

const qc = new QueryClient({ defaultOptions: { queries: { retry: 1, staleTime: 30_000, refetchOnWindowFocus: false } } });

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={qc}>
      <App />
      <Toaster />
    </QueryClientProvider>
  </StrictMode>,
);
